import { Component, OnInit } from '@angular/core';
import { ServerService } from '../services/server.service';
import * as Feather from 'feather-icons';
import Swal from 'sweetalert2'
declare var iziToast:any;
import { Router,ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-contact-group-edit',
  templateUrl: './contact-group-edit.component.html',
  styleUrls: ['./contact-group-edit.component.css']
})
export class ContactGroupEditComponent implements OnInit {
  username:any=[];
  selectedusername:any=[];
  usernameleft:any=[];
  usernameright:any=[];
  allvalue:any=[];
  groupname;
  sendnames;
  page ="add";
  sel_usernames:any=[];
    constructor(private route:ActivatedRoute,private router:Router,private serverService: ServerService) {
  
   this.route.queryParams.subscribe(params => {
        if (this.router.getCurrentNavigation().extras.state) {
  
       this.page=this.router.getCurrentNavigation().extras.state.page;
  
  
  
  if(this.page == "edit"){
       this.editcost_sender()
  
  }else{
     this.adddropdown()
  
  }
     
        }
      });
   if(this.page == "add"){
     this.adddropdown()
     }
   }
  
    ngOnInit(): void {
   
    }
  
  finishFunction(){
  
  }
  
  moveleftall(){
  this.username = [];
  this.selectedusername =[];
  this.username = this.allvalue
  }
  
  moverightall(){
  this.selectedusername =[];
  this.username = [];
  this.selectedusername = this.allvalue
  }
  
  moveleft(){

// for (var i=0;i<=this.selectedusername.length;i++){
//   var k = this.selectedusername[0];
// }
// this.selectedusername.shift(1);
// this.username.push(k);
//   return false;
console.log(this.usernameright)
  for (var i = 0; i < this.usernameright.length; i++) {
    this.username.push(this.usernameright[i])
  }
  
  
  
  for (var i = 0; i <= this.selectedusername.length; i++) {
     var ismatch = false;
    for (var j = 0; j <= this.usernameright.length; j++) {
     if(this.selectedusername[i] ==  this.usernameright[j] && this.usernameright[j]!='undefined'&& this.usernameright[j]!=undefined){
       ismatch = true;
       
      this.selectedusername.splice(this.selectedusername.indexOf(this.selectedusername[i]), 1 );
    
  
     }
   }
   if (!ismatch){
     
        
        } 
  
  }
  
  }
  
  moveright(){
    // this.username = ['1','2','3','4','5','6','7','8','9','10'];
    // for (var i = 0;i<this.username.length;i++){
    //   var k = this.username[0];

    // }
    // this.username.shift(1);
    // this.selectedusername.push(k);
    // return false;
  for (var i = 0; i < this.usernameleft.length; i++) {
    this.selectedusername.push(this.usernameleft[i])
  }
  
  
  
  for (var i = 0; i <= this.username.length; i++) {
     var ismatch = false;
    for (var j = 0; j <= this.usernameleft.length; j++) {
     if(this.username[i] ==  this.usernameleft[j]){
       ismatch = true;
  
       
      this.username.splice(this.username.indexOf(this.username[i]), 1 );
   
  
     }
   }
   if (!ismatch){
     
        
        } 
  
  }
  
  }
  
  // editcost_sender(){
  
  //   let datas:any =new Object();
  //  let datasend:any = new Object();
  //     let access_token: any=localStorage.getItem('at');
  //     let customer_id: any=localStorage.getItem('en');
  //     let senderid: any=localStorage.getItem('cos');
     
     
  // datas.action="edit_cost_sender";
  // datas.customer_id = customer_id;
  // datas.cost_sender_id = senderid;
  
  
  
  //  datasend.access_token=access_token;
  //   datasend.operation="curlDatas";
  //   datasend.moduleType="costsender";
  //   datasend.api_type="web";
  //   datasend.element_data = datas;
  //       this.serverService.sendServer(datasend).subscribe((response: any) => {
  // console.log(response)
  //   if(response.status=="true"){
  //           // this.username = response.options;
  //           for (var i = 0; i < response.options.length; i++) {
  //              this.username.push(response.options[i].value)
  //              this.allvalue.push(response.options[i].value)
  //           }
  
  //              for (var i = 0; i < response.selected_options.length; i++) {
  //              this.selectedusername.push(response.selected_options[i].value)
  //              // this.allvalue.push(response.options[i].value)
  //           }
  //           // this.selectedusername = response.selected_options;
  //           console.log(this.username)
    
  //      this.groupname=response.mapping_name;
  //           }
  //         else{
  //     // iziToast.error({
  //     //       message: "Please try again later",
  //     //       position: 'topRight'
  //     //   });
   
  //         }
   
  
  
        
  //       }, 
  //       (error)=>{
  //           console.log(error);
  //       });
  
  // }
  editcost_sender(){
  
    let datas:any =new Object();
   let datasend:any = new Object();
      let access_token: any=localStorage.getItem('at');
      let customer_id: any=localStorage.getItem('en');
      let caller_group_id: any=localStorage.getItem('cos');
     
     
  datas.action="edit_caller_id";
  datas.customer_id = customer_id;
  datas.caller_group_id = caller_group_id;
  datas.limit = '10';
  datas.offset = '0';
  
  
  
   datasend.access_token=access_token;
    datasend.operation="curlDatas";
    datasend.moduleType="costsender";
    datasend.api_type="web";
    datasend.element_data = datas;
        this.serverService.sendServer(datasend).subscribe((response: any) => {
  console.log(response)
    if(response.status=="true"){
            // this.username = response.options;
            for (var i = 0; i < response.caller_id_name.length; i++) {
               this.username.push(response.caller_id_name[i])
               this.allvalue.push(response.caller_id_name[i])
            }
  
               for (var i = 0; i < response.selected_caller_id_name.length; i++) {
               this.selectedusername.push(response.selected_caller_id_name[i])
               // this.allvalue.push(response.options[i].value)
            }
            // this.selectedusername = response.selected_options;
            console.log(this.username)
    
       this.groupname=response.group_name;
            }
          else{
      // iziToast.error({
      //       message: "Please try again later",
      //       position: 'topRight'
      //   });
   
          }
   
  
  
        
        }, 
        (error)=>{
            console.log(error);
        });
  
  }
  
  adddropdown(){
  
    let datas:any =new Object();
   let datasend:any = new Object();
      let access_token: any=localStorage.getItem('at');
      let customer_id: any=localStorage.getItem('en');
     
     
  datas.action="add_caller_id_name";
  datas.customer_id = customer_id;
  datas.limit = '10';
  datas.offset = '0';
  
  
   datasend.access_token=access_token;
    datasend.operation="curlDatas";
    datasend.moduleType="costsender";
    datasend.api_type="web";
    datasend.element_data = datas;
        this.serverService.sendServer(datasend).subscribe((response: any) => {
  console.log(response)
          if(response.status=="true"){
            // this.username = response.options;
            // for (var i = 0; i < response.options.length; i++) {
            //    this.username.push(response.options[i].value)
            //    this.allvalue.push(response.options[i].value)
            // }
            for (var i = 0; i < response.caller_id_name.length; i++) {
               this.username.push(response.caller_id_name[i])
               this.allvalue.push(response.caller_id_name[i])
            }
            console.log(this.username)
    
  
            }
          else{
      // iziToast.error({
      //       message: "Please try again later",
      //       position: 'topRight'
      //   });
   
          }
   
  
  
        
        }, 
        (error)=>{
            console.log(error);
        });
  
  }
  add_cost_sender(){
    if(this.groupname == "" || this.groupname == undefined||this.groupname == 'undefined'){
         iziToast.error({
                message: "Please Enter Group Name",
                position: 'topRight'
            });
      return false;
      }
      // alert(this.groupname)
    let access_token: any=localStorage.getItem('at');
      let customer_id: any=localStorage.getItem('en');
    let data:any = new Object();
    let datasend:any = new Object();
    data.action = 'add_group_caller_id';
    data.customer_id = customer_id;
    data.group_name = this.groupname;
    data.caller_id_name = this.selectedusername.toString();
    datasend.access_token=access_token;
    datasend.operation="curlDatas";
    datasend.moduleType="costsender";
    datasend.api_type="web";
    datasend.element_data = data;
    console.log(datasend);
    this.serverService.sendServer(datasend).subscribe((response:any)=>{
      if(response.status==true){
        this.router.navigate(['/callerid-list']);
        iziToast.success({
          message: "Caller Id Group Added",
          position: 'topRight'
      });
      }
    })

  }
  // add_cost_sender(){
  
  
  //   if(this.groupname == "" || undefined){
  //    iziToast.error({
  //           message: "Please Enter Group Name",
  //           position: 'topRight'
  //       });
  // return false;
  // }
  
  
  // this.sendnames = "";
  //   let datas:any =new Object();
  //  let datasend:any = new Object();
  //     let access_token: any=localStorage.getItem('at');
  //     let customer_id: any=localStorage.getItem('en');
     
  //    this.sendnames=this.selectedusername.join(',');
  
  
  
  // datas.action="add_cost_sender";
  // datas.customer_id = customer_id;
  // datas.mapping_name = this.groupname;
  // datas.from_display_name = this.sendnames;
  
  
  //  datasend.access_token=access_token;
  //   datasend.operation="curlDatas";
  //   datasend.moduleType="costsender";
  //   datasend.api_type="web";
  //   datasend.element_data = datas;
  //       this.serverService.sendServer(datasend).subscribe((response: any) => {
  // console.log(response)
  //         if(response.status=="true"){
  //          iziToast.success({
  //           message: "Cost Center Added Successfully",
  //           position: 'topRight'
  //       });
  
  //    this.router.navigate(['/costcenter']);
  
  //           }
  //         else{
  //     iziToast.error({
  //           message: "Please try again later",
  //           position: 'topRight'
  //       });
   
  //         }
   
  
  
        
  //       }, 
  //       (error)=>{
  //           console.log(error);
  //       });
  
  // }
  
  
  updatecost_sender(){
    if(this.groupname == "" || this.groupname == undefined || this.groupname == "undefined"){
     iziToast.error({
            message: "Please Enter Group Name",
            position: 'topRight'
        });
  return false;
  }
  
  this.sendnames = "";
  
  //   let datas:any =new Object();
  //  let datasend:any = new Object();
      let access_token: any=localStorage.getItem('at');
      let customer_id: any=localStorage.getItem('en');
     let senderid: any=localStorage.getItem('cos')
       this.sendnames=this.selectedusername.join(',');
  
  // datas.action="update_cost_sender";
  // datas.customer_id = customer_id;
  // datas.mapping_name = this.groupname;
  // datas.from_display_name = this.sendnames;
  // datas.cost_sender_id = senderid;
  
  //  datasend.access_token=access_token;
  //   datasend.operation="curlDatas";
  //   datasend.moduleType="costsender";
  //   datasend.api_type="web";
  //   datasend.element_data = datas;
  // let access_token: any=localStorage.getItem('at');
  // let customer_id: any=localStorage.getItem('en');
let data:any = new Object();
let datasend:any = new Object();
data.action = 'update_group_caller_id';
data.customer_id = customer_id;
data.group_name = this.groupname;
data.caller_group_id = localStorage.getItem('cos');
data.caller_id_name = this.selectedusername.toString();
datasend.access_token=access_token;
datasend.operation="curlDatas";
datasend.moduleType="costsender";
datasend.api_type="web";
datasend.element_data = data;
console.log(datasend);
        this.serverService.sendServer(datasend).subscribe((response: any) => {
  console.log(response)
          if(response.status=="true"){
           iziToast.success({
            message: "Caller Group Updated Successfully",
            position: 'topRight'
        });
  
     this.router.navigate(['/callerid-list']);
            }
          else{
      iziToast.error({
            message: "Please try again later",
            position: 'topRight'
        });
   
          }
   
  
  
        
        }, 
        (error)=>{
            console.log(error);
        });
  
  }
  
  
  }
  